/**
 * Type definitions for AddressCorrectionReview components
 *
 * SESSION 197: Address Correction Frontend Admin UI
 */
import type {
  AddressCorrectionDto,
  AddressCorrectionStatus
} from '@/domain/entities/AddressCorrection';

/**
 * Props for AddressCorrectionReviewSection component
 */
export interface AddressCorrectionReviewSectionProps {
  className?: string;
}

/**
 * Props for AddressCorrectionFilters component
 */
export interface AddressCorrectionFiltersProps {
  status: AddressCorrectionStatus | 'All';
  onStatusChange: (status: AddressCorrectionStatus | 'All') => void;
  onClearFilters: () => void;
}

/**
 * Props for AddressCorrectionList component
 */
export interface AddressCorrectionListProps {
  corrections: AddressCorrectionDto[];
  isLoading: boolean;
  error: Error | null;
  page: number;
  totalPages: number;
  onPageChange: (page: number) => void;
  onApprove: (correction: AddressCorrectionDto, adminNotes?: string) => Promise<void>;
  onReject: (correction: AddressCorrectionDto, rejectionReason: string, adminNotes?: string) => Promise<void>;
  actionsDisabled: boolean;
}

/**
 * Props for AddressCorrectionCard component
 */
export interface AddressCorrectionCardProps {
  correction: AddressCorrectionDto;
  onApprove: (correction: AddressCorrectionDto, adminNotes?: string) => Promise<void>;
  onReject: (correction: AddressCorrectionDto, rejectionReason: string, adminNotes?: string) => Promise<void>;
  actionsDisabled: boolean;
}

/**
 * Get status badge color
 */
export function getStatusColor(status: AddressCorrectionStatus): string {
  switch (status) {
    case 'Pending':
      return 'yellow';
    case 'Approved':
      return 'green';
    case 'Rejected':
      return 'red';
    default:
      return 'gray';
  }
}
